/**
 * The ZeaOps mark: a Z whose last stroke becomes a pulse, ending in a steady node.
 * White on an electric tile that runs from bright blue into violet, with a mint pulse node.
 */
export const LOGO_NODE = "#5CFFC4";

export function LogoMark({ size = 36, glow = true }: { size?: number; glow?: boolean }) {
  const node = glow ? `drop-shadow(0 0 ${Math.max(1.2, size / 24)}px ${LOGO_NODE})` : undefined;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      aria-hidden="true"
      style={{ display: "block" }}
    >
      <g transform="translate(-1.5 -2.75)">
        <path
          d="M12 13 H33 L13 35 H24 L26.6 29 L29.8 40.5 L32.4 35 H34.6"
          fill="none"
          stroke="url(#zh-logo-g)"
          strokeWidth="4.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="37.8" cy="35" r="3.4" fill={LOGO_NODE} style={{ filter: node }} />
      </g>
    </svg>
  );
}

export const LOGO_TILE_BACKGROUND =
  "linear-gradient(145deg, #4DA3FF 0%, #0A6CFF 45%, #6B3BFF 100%)";

export function LogoTile({ size = 44 }: { size?: number }) {
  return (
    <span
      style={{
        width: size,
        height: size,
        flex: `0 0 ${size}px`,
        borderRadius: Math.round(size * 0.3),
        background: LOGO_TILE_BACKGROUND,
        boxShadow:
          "inset 0 1px 0 rgba(255,255,255,0.35), inset 0 0 0 1px rgba(255,255,255,0.12), 0 6px 18px rgba(10,108,255,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LogoMark size={Math.round(size * 0.8)} />
    </span>
  );
}
